import { ChartLegend } from '../../../../core/components/legend/categorical/ChartLegend.js';
import { LegendSizeContext } from '../../../../core/components/legend/shared/context/LegendSizeContext.js';
import type { Dimensions } from '../../../../core/types/dimensions.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSizeContext.js';
import { useMeterBarChartData } from '../../context/MeterBarChartDataContext.js';
import { useMeterBarChartInternalConfig } from '../../context/MeterBarChartInternalConfigContext.js';

/**
 * @internal
 */
export const MeterBarChartThresholdLegend = () => {
  const { legendItems: data } = useMeterBarChartData();
  const { thresholds, thresholdsIndicators } = useMeterBarChartInternalConfig();
  const { segmentWidth, segmentHeight } = useMeterBarLayoutSize();
  const legendSize: Dimensions = { width: segmentWidth, height: segmentHeight };

  if (!data?.length || !(thresholds.legend ?? thresholdsIndicators.legend)) {
    return null;
  }

  return (
    <LegendSizeContext.Provider value={legendSize}>
      <ChartLegend
        items={data}
        interactionsDisabled
        style={{ height: '100%' }}
      />
    </LegendSizeContext.Provider>
  );
};

ChartLegend['displayName'] = 'MeterBarChartThresholdLegend';
